import React, { useEffect } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { PaginatePalletTypeState } from 'store/ducks/settings/pallet-type';

import * as S from './styles';
import { MainContainer, Paginator, MenuSelector } from 'components/shared';
import { GridPalletTypes, FilterPalletTypes } from 'components/settings';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';
import { useFilters } from 'hooks/useFilters';
export const ListPalletTypes: React.FC = () => {
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();

  const { getData } = useFilters('palletTypes');

  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginatePalletType
  ) as PaginatePalletTypeState;

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation('configuracoes')} <MenuSelector page="pallet-types" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission('insertPallets') && (
            <S.ButtonMini
              onClick={() => history.push('/settings/pallet-types/new')}
            >
              {getTranslation('novoTipo')}
            </S.ButtonMini>
          )}
          <FilterPalletTypes />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridPalletTypes palletTypes={data} />
        <Paginator
          pagination={pagination}
          settingsPage='palletTypes'
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
